import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var GlobalDataService = /** @class */ (function () {
    function GlobalDataService() {
        this.currentProjectId = new BehaviorSubject(null);
        this.currentProject = new BehaviorSubject(null);
        this.financial = null;
    }
    GlobalDataService.prototype.getUser = function () {
        return this.user;
    };
    GlobalDataService.prototype.setCurrentProjectId = function (projectId) {
        this.currentProjectId.next(projectId);
    };
    GlobalDataService.prototype.getCurrentProjectId = function () {
        return this.currentProjectId;
    };
    GlobalDataService.prototype.setCurrentProject = function (project) {
        this.currentProject.next(project);
    };
    GlobalDataService.prototype.getCurrentProject = function () {
        return this.currentProject;
    };
    GlobalDataService.prototype.getProjects = function () {
        return this.projects;
    };
    GlobalDataService.prototype.setProjects = function (projects) {
        this.projects = projects;
    };
    GlobalDataService.prototype.getUnitLabel = function (id) {
        if (this.units) {
            var found = this.units.find(function (i) { return i.id === id; });
            if (found) {
                return found.type;
            }
        }
    };
    GlobalDataService.prototype.checkStepIsBefore = function (currentStep, stepToCompare) {
        var indexCurrentStep = this.steps.findIndex(function (step) { return step.slug === currentStep; });
        var indexTopCompare = this.steps.findIndex(function (step) { return step.slug === stepToCompare; });
        return indexCurrentStep < indexTopCompare;
    };
    GlobalDataService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalDataService_Factory() { return new GlobalDataService(); }, token: GlobalDataService, providedIn: "root" });
    return GlobalDataService;
}());
export { GlobalDataService };
